<template>
  <div class="nested-inputs">
    <!-- Заголовок как input -->
    <div class="nested-header">
      <input
        class="nested-title-input"
        :value="inputs[0]?.value"
        :placeholder="inputs[0]?.placeholder || 'Заголовок'"
        @input="updateValue(0, $event.target.value)"
        @keydown.enter.prevent="save"
        aria-label="Заголовок"
      />
      <button class="nested-close" type="button" @click="$emit('close')" aria-label="Закрыть"></button>
    </div>

    <div class="nested-body">
      <draggable
        v-model="otherInputs"
        item-key="id"
        handle=".drag-handle"
        class="nested-inputs__list"
      >
        <template #item="{ element, index }">
          <div class="nested-input-item">
            <div class="nested-input__row">
              <span class="drag-handle" aria-hidden="true">☰</span>
              <input
              	v-if="element.type === 'input' || element.type === 'p' || element.type === 'h2' || element.type === 'li'"
                type="text"
                class="nested-body__input"
                :value="element.value"
                :placeholder="element.placeholder || placeholder || 'Введите значение...'"
                @input="updateValue(index + 3, $event.target.value)"
                :aria-label="element.placeholder || 'Поле'"
              />
              <textarea
              	v-if="element.type === 'textarea'"
                type="text"
                class="nested-body__input"
                :value="element.value"
                :placeholder="element.placeholder || placeholder || 'Введите значение...'"
                @input="updateValue(index + 3, $event.target.value)"
                :aria-label="element.placeholder || 'Поле'"
              />
              <MultiselectEditor
              	v-if="element.type === 'select'"
                class="nested-body__multiselect"
                v-model="element.value"
                :multiPlaceholder="'Введите список пунктов по одному'"
                @input="updateValue(index + 3, $event.target.value)"
              />
              <MultiselectEditor
              	v-if="element.type === 'radio'"
                class="nested-body__multiselect"
                v-model="element.value"
                :multiPlaceholder="'Введите список радио-кнопок по одному'"
                @input="updateValue(index + 3, $event.target.value)"
              />
              <MultiselectEditor
              	v-if="element.type === 'checkbox'"
                class="nested-body__multiselect"
                v-model="element.value"
                :multiPlaceholder="'Введите список флажков-кнопок по одному'"
                @input="updateValue(index + 3, $event.target.value)"
              />
              <div 
              	v-if="element.type === 'datetime'"
              	class="dp__container"
              >
	              <DatePicker 
	              	:isRange="element.value" 
	              	locale="ru" 
	              />
				        <CheckboxField
				          :model-value="element.value"
				          @update:model-value="updateValue(index + 3, $event)"
				        >
				        	<p>Использовать период</p>
				        </CheckboxField>
				      </div>
				      <div
				      	class="range__container"
				      	v-if="element.type === 'range'">
				      		<slider v-model="element.value" color="var(--blue-0)" track-color="#a09b9b" />
				      </div>
				      <div
				      	class="range__container"
				      	v-if="element.type === 'file'">
				      		<UploadFiles :disabled="true"/>
				      </div>
            </div>
            <div class="nested-bottom__container">
            	<button class="change-btn" type="button" @click="changeInput(index + 3)">
            		Изменить Тип - 
            		<span>{{element.label}}</span>
            	</button>
              <button class="remove-btn" type="button" @click="removeInput(index + 3)">Удалить</button>
            </div>
          </div>
        </template>
      </draggable>

      <button class="add-btn" type="button" @click="addInput">+ Добавить поле</button>
    </div>

    <div class="nested-footer">
      <button class="cancel-btn" type="button" @click="$emit('close')">
        <input
          class="footer-input"
          :value="inputs[1]?.value"
          :placeholder="inputs[1]?.placeholder || 'Отмена'"
          @input="updateValue(1, $event.target.value)"
          aria-label="Текст кнопки Отмена"
        />
      </button>

      <button class="save-btn" type="button" @click="save">
        <input
          class="footer-input"
          :value="inputs[2]?.value"
          :placeholder="inputs[2]?.placeholder || 'Сохранить'"
          @input="updateValue(2, $event.target.value)"
          aria-label="Текст кнопки Сохранить"
        />
      </button>
    </div>

    <ElementPickerModal :show="showElementPickerModal" @update:show="showElementPickerModal = $event" @select="onSelectElement" />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ElementPickerModal from '@/components/UI/Modal/ElementPickerModal.vue'
import MultiselectEditor from '@/components/UI/Select/MultiselectEditor.vue'
import DatePicker from '@/components/UI/Select/DatePicker/DatePicker.vue'
import CheckboxField from "@/components/UI/Select/Checkbox.vue";
import slider from "vue3-slider"
import UploadFiles from "@/components/UI/Upload/UploadFiles.vue";

export default {
  name: "NestedInputs",
  components: { draggable, ElementPickerModal, MultiselectEditor, DatePicker, CheckboxField, slider, UploadFiles },
  props: {
    modelValue: { type: Array, default: () => [] },
    placeholder: { type: String, default: "" }
  },
  emits: ["update:modelValue", "close", "save"],
  data() {
    const base = Date.now();
    return {
    	showElementPickerModal: false,
      defaultFields: [
        { type: "input", id: base + 1, value: "Создание заявки", placeholder: "Заголовок", label: "Заголовок" },
        { type: "input", id: base + 2, value: "Отмена", placeholder: "Отмена", label: "Кнопка" },
        { type: "input", id: base + 3, value: "Отправить", placeholder: "Сохранить", label: "Кнопка" },
        { type: "input", id: base + 4, value: "", placeholder: "Например - Укажите ваше ФИО", label: 'Текстовый ввод' }
      ],
      placeholders: [
        "Например - Укажите ваше имя",
        "Например - Номер телефона",
        "Например - Электронная почта",
        "Например - Название компании",
        "Например - Ссылка на сайт",
        "Например - Ваш город",
        "Например - Комментарий",
        "Например - Введите пароль",
        "Например - Дата рождения"
      ]
    };
  },
  computed: {
    // Полный массив полей — гарантируем минимум 4 элемента
    inputs: {
      get() {
        const mv = Array.isArray(this.modelValue) ? this.modelValue.slice() : [];
        if (mv.length === 0) return this.defaultFields.slice();
        if (mv.length < this.defaultFields.length) {
          const merged = mv.concat(this.defaultFields.slice(mv.length));
          return merged;
        }
        return mv;
      },
      set(newVal) {
        // всегда эмитим валидную копию
        this.$emit("update:modelValue", Array.isArray(newVal) ? newVal.slice() : []);
      }
    },

    // Подмассив для draggable — начиная с индекса 3 (четвёртое поле включено)
    otherInputs: {
      get() {
        return this.inputs.slice(3);
      },
      set(newVal) {
        const head = this.inputs.slice(0, 3);
        this.inputs = [...head, ...(Array.isArray(newVal) ? newVal : [])];
      }
    }
  },
  methods: {
  	onSelectElement (item) {
  		const newField = {
        type: item.type,
        id: Date.now(),
        value: "",
        label: item.label,
        placeholder: this.getRandomPlaceholder()
      };
      this.inputs = [...this.inputs, newField];
  	},
  	changeInput (item) {
  	},
    getRandomPlaceholder() {
      const i = Math.floor(Math.random() * this.placeholders.length);
      return this.placeholders[i];
    },
    addInput() {
      this.showElementPickerModal = true
    },
    removeInput(index) {
      if (index < 3) return;
      const copy = this.inputs.slice();
      copy.splice(index, 1);
      this.inputs = copy;
    },
    updateValue(index, value) {
      const copy = this.inputs.slice();
      if (!copy[index]) {
        copy[index] = { type: "input", id: Date.now() + index, value: value, placeholder: "" };
      } else {
        copy[index] = { ...copy[index], value };
      }
      this.inputs = copy;
    },
    save() {
      this.$emit("save", this.inputs.slice());
    }
  }
};
</script>

<style scoped>
.nested-inputs {
  background-color: var(--color-0);
  color: black;
  border-radius: 1rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

/* заголовок */
.nested-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.6rem;
}
/* Заголовок: инпут занимает оставшееся место */
.nested-title-input {
  flex: 1;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 0.35rem 0.6rem;
  border-radius: 0.35rem;
  border: 1px solid #ddd;
  background: white;
  box-sizing: border-box;
}

/* крестик */
.nested-close {
  position: relative;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: inline-block;
  flex: 0 0 auto;
}
.nested-close::before,
.nested-close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 14px;
  height: 2px;
  background-color: #666;
  transform-origin: center;
  transition: background-color 0.15s ease, transform 0.15s ease;
}
.nested-close::before { transform: translate(-50%, -50%) rotate(45deg); }
.nested-close::after  { transform: translate(-50%, -50%) rotate(-45deg); }
.nested-close:hover::before,
.nested-close:hover::after { background-color: #000; }

/* тело */
.nested-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.nested-inputs__list { width: 100%; }
.nested-input-item { 
	border-bottom: 0.1rem solid #5555554a;
  margin-bottom: 1.5rem;
}

.drag-handle {
  cursor: grab;
  margin-right: 0.5rem;
  user-select: none;
  display: inline-flex;
  align-items: center;
  padding: 0 0.25rem;
}

.nested-input__row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.nested-body__input {
  flex: 1;
  background-color: white;
  border: 0.1rem solid var(--grey-0);
  color: black;
  padding: 0.35rem 0.5rem;
  width: 100%;
  box-sizing: border-box;
  border-radius: 0.35rem;
}
.nested-body__input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0,0,0,0.03);
  border-color: var(--grey-0);
}

.nested-bottom__container {
	margin-top: 1rem;
	margin-bottom: 1rem;
	justify-content: space-between;
	display: flex
}


.change-btn {
  padding: 0.35rem 0.5rem;
  border-radius: 0.35rem;
  border: none;
  cursor: pointer;
  background-color: #e0e0e0;
  color: black;
  border: none;
}

.change-btn span {
	color: var(--blue-0)
}

.remove-btn {
  padding: 0.35rem 0.5rem;
  border-radius: 0.35rem;
  border: none;
  cursor: pointer;
  background: var(--);

}

/* add */
.add-btn {
  margin-top: 0.6rem;
  align-self: flex-start;
  padding: 0.45rem 0.7rem;
  border-radius: 0.35rem;
  border: none;
  cursor: pointer;
  background: #f0f0f0;
}

/* подвал */
.nested-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}
.cancel-btn,
.save-btn {
	display: contents; 
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.cancel-btn { background: #eee; }
.save-btn {	background: var(--color-1); color: #fff; }

.cancel-btn:hover ,
.save-btn:hover {
	opacity: 0.5;
}


.footer-input {
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: center;
  box-sizing: border-box;
}
.nested-inputs__list .nested-input-item:last-child { margin-bottom: 0; }

.dp__container {
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	gap: 0.5rem;
  margin-top: 1rem;
}
.range__container {
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	gap: 0.5rem;
}


@media(max-width: 768px) {
  .nested-bottom__container, .nested-footer {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .remove-btn {
    width: fit-content;
  }
  .cancel-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .save-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .nested-title-input {
    width: 3rem;
  }
}
</style>
